module.exports = {
      id: "vikatan-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#vikatan",
      toString: function () {
        return this.url;
      }
    }